<template>
  <div class="things">
    <div v-if="deatils">
      <div class="comment-main_img">
        <swiper
          :dataList="imgList"
          ref="imgSwiper"
          :swiperOption="swiperOptionImg"
        >
          <div slot="swiperMain" slot-scope="slotProps">
            <img
              class="comment-item_img"
              :src="url + slotProps.data"
              width="100%"
              height="100%"
            />
          </div>
        </swiper>
        <div class="shade"></div>
      </div>
      <div class="details">
        <a @click="addId()" ref="apply">
          <span v-bind:class="{ apply: yapply }">{{ isFull }}</span>
        </a>
        <div class="desc">
          <p @click="hide()">{{ activityName }}</p>
          <template v-if="isHidden1">
            <div class="hideBg">
              <span :class="ishide">{{ introduce }}</span>
              <a href="#" @click.stop.prevent="onShow1"></a>
              <a href="#" @click.stop.prevent="onShow1">展开</a>
            </div>
          </template>
          <template v-else>
            <!-- 显示完整内容的画面 -->
            <div class="showBg">
              <span :class="ishide">{{ introduce }}</span>
              <!-- 绑定点击事件onHide，点击收起内容 -->
              <a href="#" @click.stop.prevent="onHide1">收起</a>
            </div>
          </template>
        </div>
        <div class="line"></div>
        <div class="times">
          <infolist :id="uid" ref="infolist"></infolist>
        </div>
        <div class="line"></div>
        <div class="notice">
          <p>活动须知</p>
          <template v-if="isHidden2">
            <div class="hideBg">
              <span :class="ishide">{{ remark }}</span>
              <a href="#" @click.stop.prevent="onShow2"></a>
              <a href="#" @click.stop.prevent="onShow2">展开</a>
            </div>
          </template>
          <template v-else>
            <!-- 显示完整内容的画面 -->
            <div class="showBg">
              <span :class="ishide">{{ remark }}</span>
              <!-- 绑定点击事件onHide，点击收起内容 -->
              <a href="#" @click.stop.prevent="onHide2">收起</a>
            </div>
          </template>
        </div>
      </div>
    </div>
    <personalinfo v-else :id="uid"></personalinfo>
  </div>
</template>
<script>
import { mixin, pageAct } from "../utils";
export default {
  name: "things",
  data() {
    return {
      likeNum: 0,
      dislikeNum: 0,
      isHidden1: true,
      isHidden2: true,
      activityName: "",
      introduce: "",
      introduce1: "",
      remark: "",
      remark1: "",
      show: "",
      deatils: true,
      uid: this.$route.params.id,
      imgList: "",
      infoList: "",
      url: "",
      apply: "true",
      isFull: "活动报名",
      yapply: false,
      ishide: "hide",
      appliedQuantity: "",
      totalQuantity: "",
      swiperOptionImg: {
        autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true
        }
      },
      data: ""
    };
  },
  mixins: [mixin, pageAct],
  methods: {
    onShow1: function() {
      this.isHidden1 = false; //点击onShow切换为false，显示为展开画面
      this.introduce = this.introduce1;
    },
    onHide1: function() {
      this.isHidden1 = true; //点击onHide切换为true，显示为折叠画面
      this.strLength1();
    },
    onShow2: function() {
      this.isHidden2 = false; //点击onShow切换为false，显示为展开画面
      this.remark = this.remark1;
    },
    onHide2: function() {
      this.isHidden2 = true; //点击onHide切换为true，显示为折叠画面
      this.strLength2();
    },
    getitemList() {
      if (this.uid === "") {
        alert(1);
      } else {
      }
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl + "/api/activity/web/activity/" + this.uid
        )
        .then(response => {
          // console.log(1);
          var result = response.data;
          this.infoList = result.data;
          this.activityName = result.data.activityName;
          if (result.data.introduce) {
            if (result.data.introduce.length > 57) {
              this.introduce = result.data.introduce.substring(0, 57) + "...";
            } else {
              this.introduce = result.data.introduce.substring(0, 57);
            }
          }
          if (result.data.remark) {
            if (result.data.remark.length > 57) {
              this.remark = result.data.remark.substring(0, 57) + "...";
            } else {
              this.remark = result.data.remark.substring(0, 57);
            }
          }
          this.introduce1 = result.data.introduce;
          this.remark1 = result.data.remark;
          let imgArr = result.data.image.split(";");
          this.imgList = imgArr;
          this.appliedQuantity = result.data.appliedQuantity;
          this.totalQuantity = result.data.totalQuantity;
          // 判断是否名额已经满了
          console.log(this.totalQuantity);
          if (this.appliedQuantity < this.totalQuantity) {
            console.log("可以报名");
          } else {
            console.log("名额已经满了");
            this.isFull = "名额已满";
            this.apply = "false";
            this.yapply = true;
          }
          //判断活动是否结束
          Date.prototype.format = function(fmt) {
            var o = {
              "M+": this.getMonth() + 1, //月份
              "d+": this.getDate(), //日
              "h+": this.getHours(), //小时
              "m+": this.getMinutes(), //分
              "s+": this.getSeconds(), //秒
              "q+": Math.floor((this.getMonth() + 3) / 3), //季度
              S: this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) {
              fmt = fmt.replace(
                RegExp.$1,
                (this.getFullYear() + "").substr(4 - RegExp.$1.length)
              );
            }
            for (var k in o) {
              if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(
                  RegExp.$1,
                  RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
                );
              }
            }
            return fmt;
          };
          var myDate = new Date().format("yyyy-MM-dd hh:mm:ss");
          // let now = myDate.toLocaleString( );
          console.log(myDate);
          console.log(result.data.apStartTime, result.data.apEndTime);
          /* 活动状态分类：
          1、预约未开始
          2、预约已截止 */
          if (myDate < result.data.apStartTime) {
            this.isFull = "预约未开始";
            this.apply = "false";
            this.yapply = true;
          } else if (myDate > result.data.apEndTime) {
            this.isFull = "预约已截止";
            this.apply = "false";
            this.yapply = true;
          }
        });
    },
    addId: function() {
      if (this.apply === "true") {
        this.deatils = false;
        this.uid = this.$route.params.id;
      }
    },
    http: function() {
      this.url = window.SITE_CONFIG.baseUrl + "/api/activity/web/images/";
      // alert(this.url);
    },
    //  活动详情超出隐藏
    strLength1() {
      //活动介绍隐藏
      let hide = document.getElementsByClassName("hide")[0].innerHTML;
      if (hide.length > 57) {
        // console.log(hide.substring(0, 58))
        this.introduce = hide.substring(0, 57) + "...";
      }
    },
    strLength2() {
      //  活动须知隐藏
      let hide1 = document.getElementsByClassName("hide")[1].innerHTML;
      if (hide1.length > 57) {
        // console.log(hide1.substring(0, 58))
        this.remark = hide1.substring(0, 57) + "...";
      }
    }
  },
  mounted() {
    this.getitemList();
    this.http();
    this.$refs.infolist.getitemList();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/things.vue